export default angular.module('eventix.common.services.highlighter', [])
    .factory('Highlighter', HighlighterFactory).name;

function HighlighterFactory($document, $q, $timeout, $interval, $rootScope) {

    /**
     * @ngdoc service
     * @name eventix.common.services.Highlighter
     * @description
     * Highlight an element on the page by creating a flashing box around it.
     */
    function Highlighter() {
        this._marker = angular.element('<div class="highlight-marker"></div>');
        $document.find('body').append(this._marker);
    }

    /**
     * @ngdoc function
     * @name eventix.common.services.Highlighter#setRoot
     * @description
     * Set the root element in which to search for marking targets
     *
     * @param {Element} root A DOM element to use as root
     */
    Highlighter.prototype.setRoot = function(root) {
        this._root = angular.element(root);
    };

    /**
     * @ngdoc function
     * @name eventix.common.services.Highlighter#mark
     * @description
     * Mark element on this page (tries to find element for 10s before timing out)
     *
     * @param {String} cssPath A CSS Selector that specifies the element to highlight. Optional if a callback was
     * queud earlier.
     */
    Highlighter.prototype.mark = function(cssPath) {
        if((!angular.isString(cssPath) || cssPath === 'true') && !this.$elementFinder)
            return;
        else if(angular.isString(cssPath)) {
            cssPath += ':visible';
            this._elementFinder = function(root) {
                return root.find(cssPath);
            };
        }
        this._checker = $interval(() => {
            let el = this._elementFinder(this._root || $document);
            if(el && el.length) {
                $timeout.cancel(this._timeout);
                $interval.cancel(this._checker);
                this._elementFinder = null;
                $rootScope.$applyAsync(() => this._mark(el));
            }
        }, 500);
        this._timeout = $timeout(() => $interval.cancel(this._checker), 10000);
    };

    /**
     * @ngdoc function
     * @name eventix.common.services.Highlighter#queueMark
     * @description
     * Queue a highlight marking for a later time. Useful for delayed or more complex selectors.
     *
     * @param {Function} callback Function that returns an element
     */
    Highlighter.prototype.queueMark = function(callback) {
        this._elementFinder = function() { return angular.element(callback); };
    };

    Highlighter.prototype._mark = function(el) {
        let position = el.offset();
        $document.scrollTop(position.top - 100);
        this._marker.css({
            top: position.top,
            left: position.left,
            width: el.innerWidth(),
            height: el.innerHeight(),
            borderRadius: el.css('borderRadius'),
            display: 'block'
        });

        let update = $interval(() => {
            let newPos = el.offset();
            this._marker.css({
                top: newPos.top,
                left: newPos.left,
                width: el.innerWidth(),
                height: el.innerHeight(),
                borderRadius: el.css('borderRadius')
            });
        }, 100);
        let timeout = $timeout(() => {
            $interval.cancel(update);
            this._marker.css('display', 'none');
        }, 3000);

        this._marker.on('click', () => {
            $timeout.cancel(timeout);
            $interval.cancel(update);
            this._marker.css('display', 'none');
            this._marker.off('click');
        });
    };

    return new Highlighter();
}
